import axios from "axios";
import { authHeader } from "../authservice/auth-header";

function handleResponse(response) {
  return new Promise((resolve, reject) => {
    if (response.status === 401) {
      reject(response);
      return;
    }

    if (response.data && response.data.valid === false) {
      reject(response.data);
      return;
    }

    resolve(response.data);
  });
}

function get(url) {
  return axios
    .get(`${process.env.VUE_APP_API}${url}`, { headers: authHeader() })
    .then(handleResponse);
}

function post(url, body) {
  return axios
    .post(`${process.env.VUE_APP_API}${url}`, body, { headers: authHeader() })
    .then(handleResponse);
}

function put(url, body) {
  return axios
    .put(`${process.env.VUE_APP_API}${url}`, body, { headers: authHeader() })
    .then(handleResponse);
}

export const adminService = {
  listSolutions() {
    return get("/api/solutions").then((data) => data.items || []);
  },
  listBusinesses(params = {}) {
    const query = new URLSearchParams(params).toString();
    return get(`/api/company${query ? `?${query}` : ""}`).then((data) => data.items || []);
  },
  listRestaurants(params = {}) {
    const query = new URLSearchParams(params).toString();
    return get(`/api/company${query ? `?${query}` : ""}`).then((data) => data.items || []);
  },
  createBusiness(business) {
    return post("/api/company", business);
  },
  createRestaurant(restaurant) {
    return post("/api/company", restaurant);
  },
  updateBusiness(idBusiness, business) {
    return put(`/api/company/${idBusiness}`, business);
  },
  updateRestaurant(idRestaurant, restaurant) {
    return put(`/api/company/${idRestaurant}`, restaurant);
  },
  listUsers(idCompany = null) {
    const query = idCompany ? `?idCompany=${idCompany}` : "";
    return get(`/api/user${query}`).then((data) => data.items || []);
  },
  createUser(user) {
    return post("/api/user", user);
  },
  updateUser(idUser, user) {
    return put(`/api/user/${idUser}`, user);
  },
  setUserActive(idUser, active) {
    return put(`/api/user/${idUser}/active`, { active });
  },
  getPreferences() {
    return get("/api/user/preferences").then((data) => data.item || {});
  },
  updatePreferences(preferences) {
    return put("/api/user/preferences", preferences).then((data) => data.item || {});
  },
  getSubscription(params = {}) {
    const query = new URLSearchParams(params).toString();
    return get(`/api/account/subscription${query ? `?${query}` : ""}`).then((data) => data.item);
  },
  updateSubscription(subscription) {
    return put("/api/account/subscription", subscription);
  },
  registerSubscriptionPayment(payment) {
    return post("/api/account/subscription/payment", payment);
  },
  startPagaditoSubscriptionPayment(payment) {
    return post("/api/account/subscription/pagadito/start", payment).then((data) => data.item);
  },
  confirmPagaditoSubscriptionPayment(reference) {
    return post("/api/account/subscription/pagadito/confirm", { reference }).then((data) => data.item);
  },
  getCashClosing(params = {}) {
    const query = new URLSearchParams(params).toString();
    return get(`/api/accounting/cash-closing${query ? `?${query}` : ""}`).then((data) => data.item);
  },
  saveCashOpening(opening) {
    return post("/api/accounting/cash-opening", opening).then((data) => data.item);
  },
  saveCashExpense(expense) {
    return post("/api/accounting/cash-expense", expense).then((data) => data.item);
  },
};
